import { GridFilterOperator } from '@mui/x-data-grid';
import { ExpiresDateRangeFilterInput } from './ExpiresDateRangeFilterInput';
import {
  endOfDay,
  formatDisplayDate,
  getExpiresDateRangeValue,
  startOfDay,
} from './expiresDateUtils';
import { Invitation } from './types';

export { parseExpiresAt } from './expiresDateUtils';

export const expiresDateRangeOperator: GridFilterOperator<
  Invitation,
  Date | null,
  Date | null
> = {
  label: 'From-To',
  value: 'dateRange',
  getApplyFilterFn: filterItem => {
    const [from, to] = getExpiresDateRangeValue(filterItem.value);

    if (!from && !to) {
      return null;
    }

    const fromTime = from ? startOfDay(from).getTime() : null;
    const toTime = to ? endOfDay(to).getTime() : null;

    return value => {
      if (!(value instanceof Date) || Number.isNaN(value.getTime())) {
        return false;
      }

      const cellTime = startOfDay(value).getTime();

      if (fromTime !== null && cellTime < fromTime) {
        return false;
      }

      if (toTime !== null && cellTime > toTime) {
        return false;
      }

      return true;
    };
  },
  InputComponent: ExpiresDateRangeFilterInput,
  getValueAsString: value => {
    const [from, to] = getExpiresDateRangeValue(value);

    if (from && to) {
      return `${formatDisplayDate(from)} - ${formatDisplayDate(to)}`;
    }

    if (from) {
      return `From ${formatDisplayDate(from)}`;
    }

    if (to) {
      return `To ${formatDisplayDate(to)}`;
    }

    return '';
  },
};
